import { MetaApiResponse } from '@/utils/types/CommonApiResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAuditTrails } from './api';
import { AuditTrail } from './types';

export function useGetAuditTrails(
  params: any,
  options?: UseQueryOptions<{ data: AuditTrail[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ data: AuditTrail[]; meta: MetaApiResponse }>({
    queryKey: ['agency_audit_trails', params],
    queryFn: () => getAuditTrails(params),
    ...options
  });
}
